define('core/extensions/helpers/notNull',[],function () {
    'use strict';

    // A helper is needed to compare against null as null is not a handlebars keyword
    return function (a) {
        return a !== null;
    };
});

